import AppShell from 'components/shell/AppShell';

const PrivateUserLayout = (props) => {
  return (
    <AppShell role='user' isLoading={props.isLoading}>
      {props.children}
    </AppShell>
  );
};

export default PrivateUserLayout;
